import * as types from "../../ActionType";

const initState = {
    warehouses: [],
    loadingWarehouses: true,
    one_warehouse: {},
    loadingOneWarehouses: true,
}

const WarehousesReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_WAREHOUSE:
            return { ...state, loadingWarehouses: true }
        case types.GET_WAREHOUSES:
            return { ...state, warehouses: action.payload, loadingWarehouses: false }
        case types.GET_ONE_WAREHOUSE:
            return { ...state, one_warehouse: action.payload, loadingOneWarehouses: false }
        case types.DELETE_WAREHOUSE:
            return { ...state }
        case types.EDIT_WAREHOUSE:
            return { ...state, loadingWarehouses: true }
        default:
            return state;
    }
};

export default WarehousesReducer;
